<script>
    import * as d3 from "d3";
    import {onMount} from 'svelte';
    export let nodes;

    let container;
    
    let duration = 20000;
    let margin = {top: 6, right: 10, bottom: 22, left: 10};

    // Add colors for the top three categories
    onMount(() => {

      function draw() {
        let svg = d3.select(container);
        svg.html("");
        const width = svg.node().getBoundingClientRect().width;
        const height = width*0.256 + margin.bottom;

        var convertDimensions = d3.scaleLinear()
          .domain([0,390])
          .range([margin.left,width - margin.right]);

        const x = d3.scaleTime()
          .domain([new Date("1900/01/01"), new Date("1900/01/02")])
          .range([margin.left, width-margin.right]);

        const hours = d3.timeHours(new Date("1900/01/01"), new Date("1900/01/02"))

        svg.attr("height", height);

        const timing = d3.scaleTime()
          .domain([new Date("1900/01/01"), new Date("1900/01/02")])
          .range([0, duration]);

        let node = svg.selectAll(".node")
          .data(nodes).enter()
          .append("circle")
          .attr("class", function(d) { return "node " + d.variable; })
          .attr("cx", function (d) { return convertDimensions(d.x); } )
          .attr("cy", function (d) { return convertDimensions(d.y) - 8; } )
          .attr("r", width < 460 ? 2 : 3)
          .style("opacity", 1);

        let hourLine = svg.append("g");
        
        let path = hourLine
          .append("line")
          .attr("fill", "none")
          .attr("stroke", "#7b7b7b")
          .attr("stroke-width", 2)
          .attr("x1", margin.left)
          .attr("x2", width-margin.right)
          .attr("y1", height - 24)
          .attr("y2", height - 24);

        hourLine
        .selectAll(".hour-label")
        .data(hours)
        .enter()
        .append("text")
        .attr("class", "hour-label")
        .attr("text-anchor", "middle")
        .attr("fill", "#7b7b7b")
        .style("font-size", "12px")
        .attr("x", d => x(d))
        .attr("y", height - 6)
        .text((d,i) => i % 3 == 3 - 1 ? d3.timeFormat("%-I%p")(d) : '');
      }

      draw();

      window.addEventListener('resize', draw);

    })

</script>

<h3>On an average day, 1,160 calls are handled by 211 LA. 15% of these calls are related to <span class="emergency-shelter-span">emergency shelter</span> and 22% are for other <span class="housing-span">housing or homeless needs</span></h3>
<svg class="request-dots" bind:this={container} aria-hidden="true"></svg>